import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock, Calendar } from "lucide-react";
import { api } from "../lib/api";
import CTASection from "../components/CTASection";

export default function Blog() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  const featured = posts[0];
  const rest = posts.slice(1);

  return (
    <div data-testid="blog-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-1.5 mb-6">
              <span className="text-xs font-semibold text-teal-700 uppercase">Blog dental</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
              Cuida tu sonrisa con <span className="underline-accent">información experta</span>
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Artículos sobre salud dental escritos por nuestros especialistas. Consejos prácticos,
              prevención y todo lo que debes saber sobre tu boca.
            </p>
          </div>
        </div>
      </section>

      {featured && (
        <section className="pb-10">
          <div className="container-max">
            <Link
              to={`/blog/${featured.slug}`}
              data-testid="blog-featured"
              className="group grid lg:grid-cols-2 gap-8 items-center bg-white rounded-3xl overflow-hidden border border-slate-200 hover:shadow-xl transition-shadow"
            >
              <div className="h-80 lg:h-[400px] overflow-hidden">
                <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="p-8 lg:p-10">
                <div className="flex items-center gap-4 mb-4">
                  <span className="inline-flex items-center px-3 py-1 rounded-full bg-teal-50 text-teal-700 text-xs font-semibold">
                    {featured.category}
                  </span>
                  <span className="text-xs text-slate-500 flex items-center gap-1">
                    <Clock className="w-3 h-3" /> {featured.read_time} min
                  </span>
                </div>
                <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4 group-hover:text-teal-700 transition-colors leading-tight">
                  {featured.title}
                </h2>
                <p className="text-slate-600 leading-relaxed mb-6">{featured.excerpt}</p>
                <div className="inline-flex items-center gap-2 text-teal-700 font-semibold group-hover:gap-3 transition-all">
                  Leer artículo <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            </Link>
          </div>
        </section>
      )}

      <section className="py-16">
        <div className="container-max">
          <h2 className="text-3xl font-bold text-slate-900 mb-10">Últimos artículos</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {rest.map((p) => (
              <Link
                key={p.id}
                to={`/blog/${p.slug}`}
                data-testid={`blog-card-${p.slug}`}
                className="bg-white rounded-3xl overflow-hidden border border-slate-200 hover:shadow-lg transition-shadow group"
              >
                <div className="h-52 overflow-hidden">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="text-xs bg-teal-50 text-teal-700 px-2.5 py-1 rounded-full font-semibold">{p.category}</span>
                    <span className="text-xs text-slate-500 flex items-center gap-1">
                      <Clock className="w-3 h-3" /> {p.read_time} min
                    </span>
                  </div>
                  <h3 className="font-bold text-slate-900 text-lg mb-2 leading-snug group-hover:text-teal-700 transition-colors">
                    {p.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed line-clamp-2">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
